import Image from '@anm/components/image/Image';
import styled from 'styled-components';

export const EmbedWrapper = styled.div``;

export const ThumbnailImage = styled(Image)`
  cursor: pointer;
  display: block;
  max-width: 100%;
  object-fit: cover;
`;
